import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { QuanLyYeuCauService } from '../xu-ly/dm-quan-ly-yeu-cau/dm-quan-ly-yeu-cau.service';
import { IQuanLyYeuCau, YeuCau } from '../xu-ly/dm-quan-ly-yeu-cau/dm-quan-ly-yeu-cau';


var FileSaver = require('file-saver');
var jQuery: any;
@Component({
    selector: 'chi-tiet-yeu-cau',
    templateUrl: 'chi-tiet-yeu-cau.component.html',
    providers: [QuanLyYeuCauService]
})
export class ChiTietYeuCau implements OnInit {
    @Input("lgModalChiTietYC") lgModalChiTietYC;
    @Input("Item") set _XL(val) {
        this.YeuCau = val;        
        this.GetItem(this.YeuCau);
    };
    constructor(
        private service: QuanLyYeuCauService,
        private router: Router,
    ) { }
    SP:any={};
    YeuCau:any={};
    fileListDisplay = [];
    fileListYeuCau = [];
    ngOnInit() { 

    }
    
    GetItem(item:IQuanLyYeuCau){
        this.service.GetListId(item)
        .subscribe(
        (data) => {
            if(data.length > 0){
                //var item = jQuery.extend({}, data[0]);
                this.YeuCau = data[0];
                this.LoadDanhSachFile();
            }
        },
        er => {
            if (er.status == 401) {
                this.router.navigate(['./login']);
            }
        });
    }
    LoadDanhSachFile(){
        this.YeuCau.anh  = -1;
        this.service.LoadDSFile(this.YeuCau).subscribe(
            resp=>{
                this.fileListDisplay = resp;
            }
        )
    }   
    DownloadFile(filename){
        this.service.DownloadFile(filename).subscribe(
            resp => {
                var blob = new Blob([resp], { type: "application/octet-stream" });
                FileSaver.saveAs(blob, filename);
            }
        );
    }
    LoadDSAnh(){
        this.YeuCau.anh  = 1;
        this.service.LoadDSFile(this.YeuCau).subscribe(
            resp=>{
                this.fileListYeuCau = resp;
                //this.lgModalDSImage.show();
            }
        )
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/home/chi-tiet-yeu-cau.component.ts